import fallIcon from '@iconify/icons-ant-design/fall-outline';
import homeIcon from '@iconify/icons-ant-design/home-outline';
import riseIcon from '@iconify/icons-ant-design/rise-outline';
import React from 'react';
import * as KPI from './kpi-styles';

const iconByTrend = {
  // unsetting transform. Icons draw over everything otherwise
  rise: <KPI.IconRise style={{ transform: 'unset' }} icon={riseIcon} />,
  fall: <KPI.IconFall style={{ transform: 'unset' }} icon={fallIcon} />,
};

/**
 * This component renders the data value and trend display for a KPI card
 *
 * @param {*} props
 * @param {string} value
 * @param {string} trend up, down
 * @param {bool} small determines font and icon size
 * @param {bool} isActive determines if component should be rendered with active item styles
 */
export function TrendDisplay({
  value,
  symbol,
  trend,
  valueFontSize,
  isActive,
  enableTrend,
}) {
  return (
    <KPI.ItemData>
      <KPI.ItemNumber active={isActive} fontSize={valueFontSize}>
        {value}
      </KPI.ItemNumber>
      {symbol && <KPI.IconHome icon={homeIcon} />}
      {enableTrend && iconByTrend[trend]}
    </KPI.ItemData>
  );
}
